export default "__VITE_ASSET__$xjrjn5s__"